import React from "react";
import BannerSlide from "./BannerSlide/BannerSlide";
import {
    Container,
    CouponSwiperContainer,
} from "../CouponSwiper/StyledComponents";
import Slider from "../Slider/Slider";
import convertS3ImageUrl from "../../assets/store/convertS3ImageUrl";

function BannerSwiper({ client, banner_swiper, dataAttributes, rowData }) {
    const { isMobile } = window?.window?.deviceDetect?.getWindowData();
    const { banner_row_autoplay } = rowData;
    const { banner_slides, swiper_configuration } = banner_swiper;
    const {
        links,
        dignifi_integration,
        sunbit_integration,
        sunbit_retailer_id,
    } = client;

    const slides = banner_slides.map((slide, index) => {
        const { banner_image } = slide;
        const convertedImageUrl = convertS3ImageUrl(banner_image.image_url, {
            resize: { width: isMobile ? 600 : 2000 },
        });
        const bannerSwiperAttr = {
            "data-bannerslideid": slide.id,
            "data-clickid": slide.coupon_offer.id,
            "data-category":
                slide?.coupon_offer?.category?.name || "No Category Set",
            "data-department":
                slide?.coupon_offer?.department?.name || "No Department Set",
            "data-clickindex": index + 1,
            "data-clickurl": slide.coupon_offer.url,
            "data-coupontitle": slide.coupon_offer.name,
            ...dataAttributes,
        };

        const bannerSlideProps = {
            dataAttributes: bannerSwiperAttr,
            key: index,
            slide: slide,
            banner_image: convertedImageUrl,
            index: index,
            dignifi: dignifi_integration,
            sunbit: sunbit_integration,
            sunbitId: sunbit_retailer_id,
            links,
        };
        return <BannerSlide {...bannerSlideProps} />;
    });

    return slides?.length ? (
        <Container className="FODBannerSwiperWrapper">
            <CouponSwiperContainer className="FODBannerSwiperCouponSwiperContainer">
                <Slider
                    className="FODBannerSwiperSlider"
                    slides={slides}
                    configuration={swiper_configuration}
                    couponsPerPage={1}
                    sliderType={"banner"}
                    bannerRowAutoplay={banner_row_autoplay}
                />
            </CouponSwiperContainer>
        </Container>
    ) : null;
}

export default BannerSwiper;
